import { NgModule } from '@angular/core';

import { DetachedRouterOutlet } from './detached-router-outlet/detached-router-outlet.component';

@NgModule({
  declarations: [DetachedRouterOutlet],
  exports: [DetachedRouterOutlet],
})
export class DetachedRouterModule {}
